import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../Contexts/AuthContext/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const MobileLogoutCompnent = () => {
    const { LoginWithEmail, authUser, authId } = useContext(AuthContext);
    const from = "/";
    const navigate = useNavigate();
    const [remove, setremove] = useState(false);
  
     const SignOut = () => {

    fetch(`https://api.wlfmobile.com/api/user/auth/logout/${authUser?._id}?deviceId=${authId?.deviceId}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.success) {

          document.cookie = `WFL_token=; expires=${new Date(
            0
          ).toUTCString()}; path=/`;
          document.cookie = `mobile_version_WFL_token=; expires=${new Date(
            0
          ).toUTCString()}; path=/`;
          localStorage.removeItem("WFL_ID");
          LoginWithEmail(null);
          if (authUser === null) {
            navigate(from, { replace: true });
            toast.error(`Signout Successfully`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          setremove(true);
        }


      });


  };
    const logout = localStorage.getItem("WFL_ID");
  
    useEffect(() => {
      if (!logout && remove === true) {
        navigate(from, { replace: true });
      }
    }, [logout, remove, navigate]);
    return (
        <>
                  <li>
                  <button className="menu-item text-danger" onClick={SignOut}>
                    <span
                      style={{
                        padding: "4px",
                        backgroundColor: "red",
                        borderRadius: "4px",
                        color: "#FFF",
                      }}
                    >
                      <i className="fas text-white  fa-sign-out-alt"></i>
                    </span>
                    Log Out
                  </button>
                </li>
        </>
    );
};

export default MobileLogoutCompnent;